import Summary from './SummaryContainer';

export default Summary;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Summary/index.js